// DS: i2.4.2
import React from 'react';
import IconWrap from '../../IconWrap';
const GalleryTorpedoOutline = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "currentColor",
        d: "M21 3a1 1 0 011 1v16a1 1 0 01-1 1H3a1 1 0 01-1-1V4a1 1 0 011-1h18zm-5 10v6h4v-6h-4zm-6-8v6h10V5H10zm-6 8v6h10v-6H4zm0-8v6h4V5H4z"
    })));
};
GalleryTorpedoOutline.displayName = 'GalleryTorpedoOutline';
export default GalleryTorpedoOutline;
